/* @flow */

import * as React from 'react';

import ReactTooltip from 'react-tooltip';

import {ModalLightbox, FooterBar} from 'shells/modal';
import {ViewSubmissionHeader} from 'shells/form/view-submission-modal-content/view-submission-header';
import {ViewSubmissionData} from 'shells/form/view-submission-modal-content/view-submission-data';
import {Button} from 'shells/button';
import {CloseIcon} from 'shells/icon';
import {LoadingPage} from 'shells/loading-page';
import {ErrorState} from 'shells/error-state';
import type {SubmittedField} from 'shells/form/view-submission-modal-content/view-submission-data';

import './view-form-submission-modal.css';

type Props = {
    onClose: () => void,
    isLoading?: boolean,
    entity: {
        type: string,
        name: string,
        htmlUrlPath: string,
        initials: string,
        avatarUrl: string,
    },
    submission: ?{
        time: number,
        url: string,
    },
    form: ?{
        name: string,
        htmlUrlPath: string,
    },
    submittedFields: ?(SubmittedField[]),
};

export function ViewFormSubmissionModal(props: Props) {
    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, []);

    return (
        <ModalLightbox onClose={props.onClose}>
            <ReactTooltip
                delayShow={300}
                className='react-tooltip'
                effect='solid'
                multiline={true}
                id='close-submission-popover'
            />
            <div styleName='view-form-submission-modal'>
                <button
                    onClick={props.onClose}
                    data-tip='Close'
                    data-for='close-submission-popover'
                >
                    <CloseIcon size={17} />
                </button>
                <div styleName='view-submission-content-container'>
                    {props.isLoading ? (
                        <div styleName='special-state'>
                            <LoadingPage />
                        </div>
                    ) : (
                        <>
                            {props.submission && props.form && props.submittedFields ? (
                                <>
                                    <ViewSubmissionHeader
                                        entity={props.entity}
                                        submission={props.submission}
                                        form={props.form}
                                    />
                                    <div styleName='submission-details'>
                                        <ViewSubmissionData
                                            submittedFields={props.submittedFields}
                                        />
                                    </div>
                                </>
                            ) : (
                                <div styleName='special-state'>
                                    <ErrorState
                                        errorMessage={
                                            'We ran into trouble loading this form submission'
                                        }
                                    />
                                </div>
                            )}
                        </>
                    )}
                    <FooterBar
                        right={
                            <Button variant='text-secondary' size='big' onClick={props.onClose}>
                                Close
                            </Button>
                        }
                    />
                </div>
            </div>
        </ModalLightbox>
    );
}
